import React, { Fragment } from "react";
import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <Fragment>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <circle cx="12" cy="12" r="9.8" />
  </Fragment>,
  "RadioButtonChecked"
);
